import { CMSResource } from "app/resources/cmsresource";
import { FooterCellResource } from "app/models/FooterCellResource";
import { FooterLinksTypeResource } from "app/models/FooterLinksTypeResource";

export class FooterLinksResource extends CMSResource {

    rid: number;

    footerCellResource: FooterCellResource;

    footerLinksTypeResource: FooterLinksTypeResource;

    active: boolean;

    textRo: string;

    textFr: string;

    textEn: string;

    textDe: string;

    url: string;

    openUrlBlank: boolean;

    imagePath: string;

    imageB64: string;

    iconPath: string;

    iconB64: string;

    showEdit: boolean = false;

    orderIndex: number;

    fontFamily: string;

	fontSize: string;

    marginBottom: string;
    userEmail: string
}